import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { GmailformatPipe } from "./gmailformat.pipe";
import { CamelCasePipe } from "./camel-case.pipe";
import { NameFormatPipe } from "./name-format.pipe";

/**
 * gmail date format pipe
 */
@NgModule({
  declarations: [GmailformatPipe, CamelCasePipe,NameFormatPipe],
  imports: [CommonModule],
  exports: [GmailformatPipe, CamelCasePipe,NameFormatPipe]
})
export class ApplicationPipeModule {}
